import React from "react";
import {
  MenuIcon,
  MenuItemWrapper,
  MenuWrapper,
  StyledHeaderBrand,
  StyledHeaderWrapper,
  StyledNav,
  StyledNavItem,
} from "./styled";
import { ReactComponent as DogeLogo } from "assets/logo/logotext.svg";
import ConnectButton from "./ConnectButton";
import { handleOpen, navbarSelector } from "state/navbarSlice";
import { useSelector, useDispatch } from "react-redux";
import { motion, AnimatePresence } from "framer-motion";

const menus = ["about", "roadmap", "creator", "contact"];

const Header = () => {
  const { isNavOpen } = useSelector(navbarSelector);
  const dispatch = useDispatch();
  const FramerMenuWrapper = motion(MenuWrapper);

  return (
    <StyledHeaderWrapper isOpen={isNavOpen} as={motion.div}>
      <StyledHeaderBrand>
        <DogeLogo width={115} height={40} className="doge-logo" />
        <MenuIcon onClick={() => dispatch(handleOpen())} />
      </StyledHeaderBrand>
      <StyledNav>
        {menus.map((menu) => (
          <StyledNavItem href={`#${menu}`} key={menu}>
            {menu}
          </StyledNavItem>
        ))}
      </StyledNav>
      <AnimatePresence
        initial={false}
        exitBeforeEnter={true}
        onExitComplete={() => null}
      >
        {isNavOpen && (
          <FramerMenuWrapper
            initial={{ height: 0 }}
            animate={{ height: "fit-content" }}
            exit={{ height: 0 }}
            transition={{ type: "tween", duration: 0.15 }}
            isOpen={isNavOpen}
          >
            <MenuItemWrapper>
              {menus.map((menu) => (
                <StyledNavItem href={`#${menu}`} key={menu}>
                  {menu}
                </StyledNavItem>
              ))}
            </MenuItemWrapper>
          </FramerMenuWrapper>
        )}
      </AnimatePresence>
      <ConnectButton />
    </StyledHeaderWrapper>
  );
};

export default Header;
